module.exports = __webpack_public_path__ + "static/media/cart-down.cdb96f6a.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/cart-down.svg
// module id = 1602
// module chunks = 1